import Head from 'next/head';

export default function Main() {
	return (
		<>
			<Head>
				<title>Lucy</title>
			</Head>
			<p>Hi this is Lucy!</p>
		</>
	);
}
